import React from "react";
import "../App.css"; // Or wherever your global CSS is

const AppLogo = () => {
  return (
    <h1 className="app-logo">
      MySite
    </h1>
  );
};

export default AppLogo;
